module.exports = __webpack_public_path__ + "img/icon-compose.6fe698a8.svg";